import { Injectable } from '@angular/core';
import { exportFile } from 'common-utils/dist/csv-export';
import { BaseColumn } from '../../models/dsy-table.model';

@Injectable({ providedIn: 'root' })
export class ExportCSVService {
  exportFromTable<T extends object, K extends string>(rows: readonly T[], columns: readonly BaseColumn<T, K>[], fileName: string, locale?: string): void {
    const columnsToExport = columns.filter(col => col.header && col.header.trim() !== '' && col.key !== 'action');
    const csv = this.buildCSV(rows, columnsToExport, locale);
    const fullFileName = this.buildFileName(fileName);
    exportFile(csv, fullFileName);
  }

  private buildCSV<T extends object, K extends string>(rows: readonly T[], columns: readonly BaseColumn<T, K>[], locale?: string): string {
    const headers = columns.map(c => c.header.toUpperCase());
    const dataRows = rows.map(row => columns.map(col => (col.exportAccessor ? col.exportAccessor(row, locale) : col.accessor(row)) ?? '').join(','));
    return [headers.join(','), ...dataRows].join('\n');
  }

  private buildFileName(documentName: string): string {
    const now = new Date();
    const pad = (v: number) => String(v).padStart(2, '0');
    const timestamp = now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate()) + pad(now.getHours()) + pad(now.getMinutes());
    return `${documentName}_${timestamp}`;
  }
}
